/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceSummary } from './DeviceSummary';
import {
    DeviceSummaryFromJSON,
    DeviceSummaryFromJSONTyped,
    DeviceSummaryToJSON,
    DeviceSummaryToJSONTyped,
} from './DeviceSummary';

/**
 * 
 * @export
 * @interface ListDevicesResponse
 */
export interface ListDevicesResponse {
    /**
     * 
     */
    devices: Array<DeviceSummary>;
}

/**
 * Check if a given object implements the ListDevicesResponse interface.
 */
export function instanceOfListDevicesResponse(value: object): value is ListDevicesResponse {
    if (!('devices' in value) || value['devices'] === undefined) return false;
    return true;
}

export function ListDevicesResponseFromJSON(json: any): ListDevicesResponse {
    return ListDevicesResponseFromJSONTyped(json, false);
}

export function ListDevicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListDevicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'devices': ((json['devices'] as Array<any>).map(DeviceSummaryFromJSON)),
    };
}

export function ListDevicesResponseToJSON(json: any): ListDevicesResponse {
    return ListDevicesResponseToJSONTyped(json, false);
}

export function ListDevicesResponseToJSONTyped(value?: ListDevicesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'devices': ((value['devices'] as Array<any>).map(DeviceSummaryToJSON)),
    };
}

